export default "__VITE_ASSET__CX$Oiz5h__"